import { FC, ReactNode, useState } from 'react';
import { LoadingOutlined, EditOutlined } from '@ant-design/icons';
import { ProTypography } from '../../antd';
import classNames from 'classnames';
import { IEditableProps } from '../interface';
import { SUCCESS_STATUS_CODE } from '../../constants/constant';

interface EdiTableProps extends IEditableProps {
  /** 当前行数据 */
  record: any;
  /** 当前单元格数据 */
  text: ReactNode;
  /** 修改成功 */
  onSuccess: (value: string, data: any) => void;
  /** 是否必填 */
  isRequired?: boolean;
  /** 类名 */
  className?: string;
}
/** 编辑单元格 */
const EdiTable: FC<EdiTableProps> = props => {
  const {
    icon,
    maxLength,
    tooltip,
    fetchApi,
    searchName,
    rowKey,
    rowKeyName,
    formatParams,
    record,
    text,
    isRequired,
    className,
    onSuccess,
  } = props;
  const [editing, setEditing] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [hover, setHover] = useState<boolean>(false);
  const handleStart = () => {
    setEditing(true);
  };
  const handleChange = async (value: string) => {
    setEditing(false);
    if (value === text) return;
    if (isRequired && !value) return;
    let params: any = {};
    params[rowKeyName || rowKey] = record[rowKey];
    if (searchName) params[searchName] = value;
    if (formatParams) {
      params = formatParams(params, record);
      if (!params) return false;
    }
    setLoading(true);
    const res = await fetchApi(params);
    setLoading(false);
    if (res.code === SUCCESS_STATUS_CODE) {
      onSuccess(value, res.data);
    }
  };
  const handleMouseLeave = () => {
    setHover(false);
  };
  const classes = classNames("table-typography-edit", className,);
  return (
    <div
      style={{display: 'inline-block'}}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={() => setHover(true)}
    >
      {
        hover || editing ? (
          <ProTypography.Paragraph
            className={classes}
            editable={{
              editing,
              maxLength,
              tooltip,
              icon: loading ? <LoadingOutlined /> : icon || <EditOutlined />,
              onStart: handleStart,
              onChange: handleChange,
            }}
          >
            {text}
          </ProTypography.Paragraph>
        ) : text
      }
    </div>
  );
};

EdiTable.defaultProps = {
  isRequired: true,
};

export default EdiTable;
